import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  fileNameColor: {
    color: "#A2A9BD",
  },
  fileWrapper: {
    textAlign: "left",
    margin: "8px 0",
    width: "100%",
    position: "relative",
  },
  fileContainer: {
    backgroundColor: "#E9EEF4",
    width: "100%",
    position: "relative",
    border: "dashed",
    borderRadius: 1,
    borderColor: "#e4eaec",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  fileInput: {
    position: "absolute",
    opacity: "0%",
    width: "100%",
    height: "100%",
    cursor: "pointer",
    display: "none",
  },
  imageOverlay: {
    position: "absolute",
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.3)",
    zIndex: 40,
  },
  fileButton: {
    backgroundColor: "#f1f5ff",
    borderRadius: 28,
    padding: "8px 28px",
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 600,
    color: theme.palette.primary.main,
    zIndex: 50,
    cursor: "pointer",
    transition: ".2s all ease-in-out",
    "&:hover": {
      backgroundColor: "#ced2d4",
      color: "#76838f",
    },
  },
  fileNameAlign: {
    textAlign: "right",
  },
  fileNameTruncate: {
    marginTop: 3,
    fontFamily: "Lato",
    fontSize: theme.typography.pxToRem(16),
    display: "inline-block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "350px",
    [theme.breakpoints.down(601)]: {
      maxWidth: "260px",
    },
    [theme.breakpoints.down(481)]: {
      maxWidth: "194px",
    },
    [theme.breakpoints.down(391)]: {
      maxWidth: "156px",
    },
    [theme.breakpoints.down(361)]: {
      maxWidth: "125px",
    },
    [theme.breakpoints.down(321)]: {
      maxWidth: "98px",
    },
    [theme.breakpoints.down(300)]: {
      maxWidth: "68px",
    },
  },
}));
